import React from "react";
import { useTranslation } from "react-i18next";
import BluePenIcon from "../../../../assets/icons/blue-pen.svg";
import "./EditCategoryActionsModal.less";

export type EditCategoryActionsModalProps = {
  name: string;
  onClose: () => void;
  onRequestDelete?: (name: string) => void;
  onRequestEdit?: (name: string) => void;
  onRequestCreate?: () => void;
};

const EditCategoryActionsModal: React.FC<EditCategoryActionsModalProps> = ({ name, onClose, onRequestDelete, onRequestEdit, onRequestCreate }) => {
  const { t } = useTranslation();

  const handleOverlayClick = () => onClose?.();
  const handleModalClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => e.stopPropagation();

  return (
    <div className="edit-category-actions-bottom-modal-overlay" onClick={handleOverlayClick}>
      <div className="edit-category-actions-bottom-modal-content" onClick={handleModalClick}>
        <div className="modal-header-line-wrapper">
          <div className="modal-header-line"></div>
        </div>

        <div className="edit-category-actions-bottom-modal-container">
          <img src={BluePenIcon} className="edit-category-actions-bottom-modal-icon" alt="Edit" />
          <div className="edit-category-actions-bottom-modal-title">{t("edit-category-actions-title", { name })}</div>
          <div className="edit-category-actions-bottom-modal-desc">{t("edit-category-actions-desc")}</div>

          <button
            type="button"
            className="edit-category-actions-button"
            onClick={() => {
              onClose?.();
              onRequestEdit?.(name);
            }}
          >
            {t("edit-category-actions-rename")}
          </button>
          <button
            type="button"
            className="edit-category-actions-button"
            onClick={() => {
              onClose?.();
              onRequestCreate?.();
            }}
          >
            {t("edit-category-actions-add")}
          </button>
          <button
            type="button"
            className="edit-category-actions-button"
            onClick={() => {
              onClose?.();
              onRequestDelete?.(name);
            }}
          >
            {t("edit-category-actions-delete")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditCategoryActionsModal;
